import React, { useState } from 'react';
import axios from 'axios';
import Financials from './Financials';
import './PublicFinancials.css';

const baseURL = 'https://lionfish-app-w73zu.ondigitalocean.app/api/';

const PublicFinancials = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedClubId, setSelectedClubId] = useState(null);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (selectedClubId) setSelectedClubId(null);

    if (query.length > 2) {
      try {
        const response = await axios.get(`${baseURL}myclub/search-golf-clubs/?query=${query}`);
        setSearchResults(response.data.results);
        setError(null);
      } catch (err) {
        console.error("Search API Error:", err);
        setSearchResults([]);
        setError("Error fetching search results. Please try again.");
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleClubSelect = (club) => {
    setSelectedClubId(club.club_id);
    setSearchQuery(club.name);
    setSearchResults([]);
  };

  return (
    <div className="club-financials-page">
      <header className="page-header2">
        <h1>Club Financial Explorer</h1>
      </header>

      <div className="search-container">
        <div className="search-input-container">
          <svg className="search-icon" viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search by club name or location..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        {searchResults.length > 0 && (
          <div className="search-results-container">
            {searchResults.map((club) => (
              <div
                key={club.club_id}
                onClick={() => handleClubSelect(club)}
                className="search-result-card"
              >
                <div className="club-info">
                  <h3 className="club-name">{club.name}</h3>
                  <p className="club-location">{club.address}, {club.city}, {club.state}</p>
                </div>
                <span className="view-financials-cta">View Financials →</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedClubId && (
        <section className="financials-section2">
          <Financials clubId={selectedClubId} />
        </section>
      )}
    </div>
  );
};

export default PublicFinancials;